import React from 'react';
import {
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { COLORS } from '../../../../constants/color';
import moment from 'moment';

function SimpleLine(props) {
  const { data, activeDateRangeToken, activeTokenTab } = props;

  // 데이터 키 추출
  const dataKeys = Object?.keys(data[0])?.filter(key => (key !== 'time' && key !== 'miningHvh'));

  // 날짜 필터링
  const today = moment.utc().format('YYYY-MM-DD');
  // const day = moment(today).subtract(1, 'days').format('YYYY-MM-DD');

  const filterDataByDateRange = (data, token) => {
    let startDate;

    startDate = moment(today).subtract(token, 'days').format('YYYY-MM-DD');

    console.log(startDate, '~', today);

    return data?.filter(item => moment(item?.time).isBetween(startDate, today, null, '[)'));
  };

  const filteredData = activeDateRangeToken ? filterDataByDateRange(data, activeDateRangeToken) : data;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer>
        {/* 선 그래프 */}
        {data.length > 0 ?
          <LineChart data={filteredData}>
            {/* X축 설정 */}
            <XAxis dataKey="time" tickLine={false} tickFormatter={(time) => timeFormAPI.changeDataDate(time)}/>
            {/* Y축 설정 */}
            <YAxis axisLine={false} tickSize={3} tickLine={false} tick={{ stroke: 'none' }}/>
            {/* 그리드 설정 */}
            <CartesianGrid vertical={false} strokeDasharray="3 3"/>
            {/* X축 레이블 설정 */}
            <CartesianAxis vertical={false}/>
            {/* 도구팁 설정 */}
            <Tooltip/>
            {/* 범례 설정 */}
            <Legend iconType="circle" verticalALign="bottom" iconSize={10}/>

            {/* 데이터 키에 대한 동적 매핑 */}
            {activeTokenTab
              ? dataKeys
                .filter(dataKey => {
                  // 데이터 키의 토큰 부분 추출 및 대문자로 변환
                  const tokenKey = dataKey?.substring(6)
                    .toUpperCase();
                  // activeTokenTab에 해당 토큰이 있는지 확인하여 필터링
                  return activeTokenTab[tokenKey];
                })
                .map((filteredKey, index) => {
                  // 채굴 및 소비 여부 확인
                  const isMining = filteredKey?.startsWith('mining');
                  const isBurned = filteredKey?.startsWith('burned');

                  // 표시할 이름 설정
                  let displayName = filteredKey; // 기본값은 필터된 키로 설정

                  if (isMining) {
                    displayName = `채굴${filteredKey?.substring(6)
                      .toUpperCase()}`; // "mining" 접두어 제거
                  } else if (isBurned) {
                    displayName = `소비${filteredKey?.substring(6)
                      .toUpperCase()}`; // "burned" 접두어 제거
                  }

                  // 선 그래프 컴포넌트 렌더링
                  return (
                    <Line
                      key={index}
                      type="monotone"
                      dataKey={filteredKey}
                      strokeWidth={2}
                      stroke={COLORS[filteredKey] || `#${Math.floor(Math.random() * 16777215)
                        .toString(16)}`}
                      dot={{ r: 3 }}
                      // activeDot={{ r: 8 }}
                      name={displayName}
                      legendType={isMining || isBurned ? 'line' : 'square'}
                    />
                  );
                })
              : dataKeys.map((filteredKey, index) => {
                // 채굴 및 소비 여부 확인
                const isMining = filteredKey?.startsWith('mining');
                const isBurned = filteredKey?.startsWith('burned');

                // 표시할 이름 설정
                let displayName = filteredKey; // 기본값은 필터된 키로 설정

                if (isMining) {
                  displayName = `채굴${filteredKey?.substring(6)
                    .toUpperCase()}`; // "mining" 접두어 제거
                } else if (isBurned) {
                  displayName = `소비${filteredKey?.substring(6)
                    .toUpperCase()}`; // "burned" 접두어 제거
                }

                // 선 그래프 컴포넌트 렌더링
                return (
                  <Line
                    key={index}
                    type="monotone"
                    dataKey={filteredKey}
                    strokeWidth={2}
                    stroke={COLORS[filteredKey] || `#${Math.floor(Math.random() * 16777215)
                      .toString(16)}`}
                    dot={{ r: 3 }}
                    // activeDot={{ r: 8 }}
                    name={displayName}
                    legendType={isMining || isBurned ? 'line' : 'square'}
                  />
                );
              })
            }
          </LineChart>
          : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#FAFBFC' }}>
            해당 기간의 데이터 없음
          </div>
        }
      </ResponsiveContainer>
    </div>
  );
}

export default SimpleLine;
